// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import assetEntity from './entities/asset.json';
import assetMenu from '../pages/asset/menu.json';
import assetFullForm from '../pages/asset/forms/full.json';
import assetContextForm from '../pages/asset/forms/context.json';
import assetMiniForm from '../pages/asset/forms/mini.json';
import assetLookupForm from '../pages/asset/forms/lookup.json';
import assetTableView from '../pages/asset/views/table.json';
import assetStagesView from '../pages/asset/views/stages.json';
import assetCardsView from '../pages/asset/views/cards.json';
import assetSplitView from '../pages/asset/views/split.json';
import assetCalendarView from '../pages/asset/views/calendar.json';
import assetDashboardView from '../pages/asset/views/dashboard.json';

/** Тип запису «Майно» зі сторінками пакета: меню, форми та подання з pages/asset/. */
export const assetDefinition: IRecordTypeDefinition = {
  ...assetEntity,
  views: assembleViewSet({
      table: assetTableView,
      stages: assetStagesView,
      cards: assetCardsView,
      split: assetSplitView,
      calendar: assetCalendarView,
      dashboard: assetDashboardView,
  }),
  form: assetFullForm,
  forms: { full: assetFullForm, context: assetContextForm, mini: assetMiniForm, lookup: assetLookupForm },
  menu: assetMenu,
} as IRecordTypeDefinition;
